import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import TextLoader from '../Loader/TextLoader';
import InView from '../InView';

const inViewPredictionsPropertyTypes = {
  url: PropTypes.string.isRequired,
};

type InViewPredictionsProperties = InferProps<
  typeof inViewPredictionsPropertyTypes
>;

const DynamicPredictions = dynamic(() => import('./Predictions'), {
  ssr: false,
  loading: TextLoader,
});

const InViewPredictions = ({ url } : InViewPredictionsProperties) => {
  const { query: { predictions } } = useRouter();

  if (predictions !== 'true') {
    return null;
  }

  return (
    <InView>
      <DynamicPredictions url={url} />
    </InView>
  );
};

InViewPredictions.propTypes = inViewPredictionsPropertyTypes;

export default InViewPredictions;
